import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
    btn: {
        height: "37px",
        background: "#9A0143",
        fontFamily: "Rubik",
        fontSize: "12px",
        color: "#fff",
        "&:hover": {
            backgroundColor: "#9A0143",
        },
    },
});
